import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";
import { useSelector } from "react-redux";

export default function LoginPage(props: any) {
  localStorage.setItem("BIHeaderTitle", "");

  const jsonFile = useSelector((state: any) => state.style);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <div className="row login">
        <Box
          className="bodyForms-ex BodyFormVerify"
          sx={{
            my: 1,
            mx: "auto",
            borderRadius: "10px",
            overflow: "hidden",
            // width: "625px",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2)",
          }}
        >
          <Grid
            container
            wrap="nowrap"
            spacing={2}
            justifyContent="center"
            style={{
              marginBottom: "8vh",
            }}
            sx={{ minWidth: { lg: "600px" } }}
          >
            {(props.api == undefined || props.api.isCalled === false) && (
              <Grid item xs>
                {props.childForm}
                {jsonFile?.loginTitle ? (
                  <div
                    className="iranSansFaNum textCenter colorTitle textFont14"
                    style={{
                      marginBottom: "5vh",
                      padding: "8px",
                      maxWidth: "475px",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    dangerouslySetInnerHTML={{ __html: jsonFile.loginTitle }}
                  ></div>
                ) : (
                  ""
                )}
              </Grid>
            )}
          </Grid>
        </Box>
      </div>
    </div>
  );
}
